const TeamStatisticsTypes = {
    GET_TEAM_STATISTICS_START:'GET_TEAM_STATISTICS_START',
    GET_TEAM_STATISTICS_SUCCESS:'GET_TEAM_STATISTICS_SUCCESS',
    GET_TEAM_STATISTICS_FAILED:'GET_TEAM_STATISTICS_FAILED',

}

export default TeamStatisticsTypes